import { CategoryType } from "@digits-graphql/frontend/graphql-bearer"

const CATEGORY_TYPE_LABEL_MAP = new Map<CategoryType, string>([
  [CategoryType.Income, "Revenue"],
  [CategoryType.Expenses, "Expenses"],
])

export function insightComponentTitle(type: CategoryType | undefined) {
  if (!type || !CATEGORY_TYPE_LABEL_MAP.has(type)) return "Insight"

  return `${CATEGORY_TYPE_LABEL_MAP.get(type)} Analysis`.trim()
}
